import { TableCell } from '@/components/ui';
import { IHasUser } from '.';

export const DataTableBodyCellEmail = ({ user }: IHasUser) => (
  <TableCell className='py-1 pe-0 max-w-[200px] truncate whitespace-nowrap overflow-hidden'>
    {user.email}
  </TableCell>
);

export default DataTableBodyCellEmail;
